// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TMe1","buttons":"styles_buttons__-7uhm"};